<template>
  <b-form-datepicker
    :min="actualDate"
    :max="maxDate"
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    :date-disabled-fn="dateDisabled"
    locale="es"
    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
  ></b-form-datepicker>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "Calendar",
  props: ["value"],
  data() {
    return {
      estimatedDateV: "",
      restrictedDaysC: [],
      actualDate: moment().add(1, 'days').format("YYYY-MM-DD"),
    };
  },
  created() {
    this.getRestrictedDays();
  },
  computed: {
    maxDate() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      const maxDate = new Date(today);
      maxDate.setMonth(maxDate.getMonth() + 2);
      return maxDate;
    },
  },
  methods: {
    dateDisabled(ymd) {
      //const weekday = date.getDay();
      let isDisabled = false;
      this.restrictedDaysC.forEach((item) => {
        if (ymd === item) {
          isDisabled = true;
        }
      });
      //return isDisabled || weekday === 0;
      return isDisabled;
    },
    async getRestrictedDays() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_RESTRICTIONS_BASE +
            "/restricted_days/dates?dateFormat=yyyy-MM-dd"
        );
        this.restrictedDaysC = response.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
</style>